export default class EventManager {

    constructor() {
        this.registeredEvents = {};
        this.listeners = {};
    }

    createEvent(id, name, description = null) {

        if (this.registeredEvents[id]) {
            return this;
        }
        this.registeredEvents[id] = {
            name,
            description
        };
        if (this.listeners[id]) {
            this.listeners[id].forEach(callback => {
                window.addEventListener(id, callback);
            });
        }

        return this;
    }

    triggerEvent(id, detail = {}) {
        if (!this.registeredEvents[id]) {
            throw new Error(`Event '${id}' has not been registered.`);
        }
        window.dispatchEvent(
            new CustomEvent(id, {
                detail
            })
        );
    }

    subscribe(id, callback) {
        if (!this.listeners[id]) {
            this.listeners[id] = [];
        }
        this.listeners[id].push(callback);
        if (this.registeredEvents[id]) {
            window.addEventListener(id, callback);
        }
    }

    list(needle) {
        return Object.keys(this.registeredEvents)
            .filter(id => id.startsWith(needle));
    }

}